export default () => [
  {
    field: "seq",
    width: 50,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    field: "saveStatus",
    align: "center",
    width: 100,
    title: "导入状态",
    slots: { default: "status" },
  },
  {
    field: 'errorMsg',
    align: 'left',
    headerAlign: 'center',
    title: '导入异常原因',
    width: 200,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: "carrierSortInfo",
    width: 100,
    align: "center",
    title: "承运商序号",
  },
  {
    field: 'carrierName',
    title: '承运商名称',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'carrierShortName',
    align: 'center',
    minWidth: 120,
    title: '承运商简称',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'parentCarrierName',
    align: 'center',
    minWidth: 120,
    title: '结算承运商',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'carrierTypeName',
    align: 'left',
    minWidth: 120,
    title: '承运商类型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'businessLicense',
    align: 'left',
    minWidth: 120,
    title: '营业执照号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'establishmentDate',
    align: 'center',
    minWidth: 150,
    title: '成立日期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'legalRepresentative',
    align: 'center',
    minWidth: 120,
    title: '法定代表人',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'registeredCapital',
    align: 'center',
    minWidth: 120,
    title: '注册资金',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'registeredAddress',
    align: 'center',
    minWidth: 120,
    title: '注册地址',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'businessAddress',
    align: 'center',
    minWidth: 120,
    title: '经营地址',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'businessLicenseValidity',
    align: 'center',
    minWidth: 150,
    title: '营业执照有效期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'roadOperationLicenseValidity',
    align: 'center',
    minWidth: 175,
    title: '道路运行许可证有效期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'safetyAccessValidity',
    align: 'center',
    minWidth: 175,
    title: '安全准入备案证有效期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'isoOneValidity',
    align: 'center',
    minWidth: 150,
    title: 'ISO9001有效期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'isoTwoValidity',
    align: 'left',
    minWidth: 150,
    title: 'ISO14001有效期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'isoThreeValidity',
    align: 'left',
    minWidth: 150,
    title: 'ISO18001有效期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'sqasNumber',
    align: 'left',
    minWidth: 120,
    title: 'SQAS报告号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'transportationLicense',
    align: 'center',
    minWidth: 120,
    title: '运输许可资质',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'depositBank',
    align: 'center',
    minWidth: 120,
    title: '开户银行',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'bankAccount',
    align: 'left',
    minWidth: 120,
    title: '银行账号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'bankAccountName',
    align: 'left',
    minWidth: 120,
    title: '账号名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'invoiceTitle',
    align: 'left',
    minWidth: 120,
    title: '发票抬头',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'taxNumber',
    align: 'left',
    minWidth: 120,
    title: '税号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'invoiceAddress',
    align: 'left',
    minWidth: 120,
    title: '开票地址',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'phoneNo',
    align: 'left',
    minWidth: 120,
    title: '固定电话',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'financialCode',
    align: 'left',
    minWidth: 120,
    title: '财务代码',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'carrierSettlementConditionName',
    align: 'left',
    minWidth: 120,
    title: '结算条件',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'isAutoSettlement',
    align: 'left',
    minWidth: 150,
    title: '是否自动生成账单',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'carrierSettlementDate',
    align: 'left',
    minWidth: 120,
    title: '账单生成日',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'isExpress',
    align: 'left',
    minWidth: 140,
    title: '是否是快递公司',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'apiCarrierNo',
    align: 'left',
    minWidth: 120,
    title: '快递公司代码',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'roadOperationLicenseScope',
    align: 'left',
    minWidth: 200,
    title: '道路运营许可证经营范围',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'carrierRemarks',
    align: 'left',
    minWidth: 150,
    title: '备注信息',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
];
